import { render, staticRenderFns } from "./OpenChatInput.vue?vue&type=template&id=70a935b4&"
import script from "./OpenChatInput.vue?vue&type=script&lang=js&"
export * from "./OpenChatInput.vue?vue&type=script&lang=js&"
import style0 from "./OpenChatInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports